<template>
  <v-select
    ref="inner"
    v-bind="mergedAttrs"
    v-on="$listeners"
    :class="mergedClass">
    <!-- eslint-disable-next-line vue/require-v-for-key -->
    <template v-for="(_, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"/>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'MankSelect',
  inheritAttrs: false,
  computed: {
    mergedClass() {
      const c = this.$attrs.class;
      return ['mank-select', c].filter(Boolean);
    },
    mergedAttrs() {
      const a = { ...this.$attrs };
      delete a.class;

      if (a.outlined === undefined) a.outlined = true;

      if (a.hideDetails === undefined && a['hide-details'] === undefined) {
        const msgs = a.errorMessages;
        const hasErr = msgs && (Array.isArray(msgs) ? msgs.length : String(msgs).length);
        const hasRules = a.rules && a.rules.length;
        a.hideDetails = (hasErr || hasRules) ? 'auto' : true;
      }

      if (a.height === undefined) a.height = '32';
      if (a.elevation === undefined) a.elevation = 0;

      if (a.menuProps === undefined && a['menu-props'] === undefined) {
        a.menuProps = {
          maxHeight: 300,
          offsetY: true,
          nudgeBottom: 8,
        };
      }

      return a;
    },
  },
};
</script>
